import { TimePeriods } from '../../../../src/constants';
import { parseISO } from 'date-fns';

export const getIntervalLastDates = (timeIntervals, period, timePeriod) => {
    if (period === TimePeriods['Custom Date']) {
        if (!timePeriod?.startDate || !timePeriod?.endDate) return null;
        return {
            from: parseISO(timePeriod.startDate),
            to: parseISO(timePeriod.endDate),
            lastIntervalText: TimePeriods['Custom Date']
        };
    }

    const interval = timeIntervals?.find(t => t?.intervalType === period);
    if (!interval) return null;

    return {
        from: interval.last?.from ? new Date(interval.last.from) : undefined,
        to: interval.last?.to ? new Date(interval.last.to) : undefined,
        lastIntervalText: interval.lastIntervalText || period
    };
};
